module.exports = __webpack_public_path__ + "static/media/PlayStore.fc1623c5.svg";